import OlbLogo from './logo.vue';
export default OlbLogo;
